// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export * from "./UserDelegationKeyCredential-browser.mjs";
